<template>
  <a-row :gutter="16">
    <a-col v-for="(item, idx) in dataList" :key="idx" :span="4" @click="openDetail(item)">
      <a-card :body-style="{ padding: '20px' }" style="border-radius: 8px" size="small">
        <template slot="title">{{ item.lable }}</template>
        <div style="height: 110px; font-weight: 500; text-align: center; font-size: 60px; color: #201d1d">
          {{ item.value }}
        </div>
      </a-card>
    </a-col>
    <BusinessRequirementListModal ref="businessRequirementListModalRef" />
  </a-row>
</template>

<script>
import { getBrBaseCollecter } from '@/api/business/requirement';
import BusinessRequirementListModal from '@/pages/business/requirement/components/BusinessRequirementListModal';

export default {
  components: { BusinessRequirementListModal },
  props: {
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dataList: [
        { lable: '需求总数', value: 0 },
        { lable: '需求问答中', value: 0 },
        { lable: '进入生产需求', value: 0 },
        { lable: '已交付', value: 0 },
        { lable: '需求作废数', value: 0 }
      ]
    };
  },
  watch: {
    filterForm() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    openDetail(item) {
      const searchParams = {
        ...this.filterForm,
        statusList: []
      };
      if (item.lable === '需求总数') {
        this.$refs.businessRequirementListModalRef.open(item.lable, searchParams);
      } else if (item.lable === '需求问答中') {
        this.$refs.businessRequirementListModalRef.open(item.lable, { ...searchParams, statusList: [134] });
      } else if (item.lable === '进入生产需求') {
        this.$refs.businessRequirementListModalRef.open(item.lable, { ...searchParams, statusList: [135, 136, 137] });
      } else if (item.lable === '已交付') {
        this.$refs.businessRequirementListModalRef.open(item.lable, { ...searchParams, statusList: [140] });
      }
    },
    getData() {
      getBrBaseCollecter({ ...this.filterForm }).then(res => {
        const datas = res.data || [];

        this.dataList[0].value = datas.find(item => item.name === '需求总数')?.count || 0;
        this.dataList[1].value = datas.find(item => item.name === '需求问答中')?.count || 0;
        this.dataList[2].value = datas.find(item => item.name === '进入生产需求')?.count || 0;
        this.dataList[3].value = datas.find(item => item.name === '已交付')?.count || 0;
        this.dataList[4].value = datas.find(item => item.name === '需求作废数')?.count || 0;

        // datas.forEach(item => {
        //   if (item.name === '需求总数') {
        //     this.dataList[0].value = item.count || 0;
        //   } else if (item.name === '需求问答中') {
        //     this.dataList[1].value = item.count || 0;
        //   } else if (item.name === '进入生产需求') {
        //     this.dataList[2].value = item.count || 0;
        //   } else if (item.name === '已交付') {
        //     this.dataList[3].value = item.count || 0;
        //   } else if (item.name === '需求作废数') {
        //     this.dataList[4].value = item.count || 0;
        //   }
        // });
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
